// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"87437b03","702":"52102d5f","840":"70feabb5"}[chunkId] + ".chunk.js";
};